import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { DEFAULTS } from 'constants/defaults.constant';

import { getValue } from 'components/generics/getValue';

import { parseThousand } from 'utils/parser.utils';

import { INftCardCurrencyAndValue } from '../types';

interface INftCardValueProps extends INftCardCurrencyAndValue {
  ariaLive?: boolean;
  precision?: number;
  /** Drop trailing zero decimals (e.g. 18.00 → 18, 18.50 → 18.5). */
  trimTrailingZeros?: boolean;
  currencyClassName?: string;
  valueClassName?: string;
}

const NftCardValue: FC<INftCardValueProps> = ({
  currency,
  value,
  precision = DEFAULTS.defaultPricePrecision,
  trimTrailingZeros = false,
  ariaLive = false,
  currencyClassName,
  valueClassName,
}) => {
  const renderValue = (value: string) => {
    if (!value) return '—';
    const num = parseFloat(value);
    if (!isFinite(num)) return '—';
    if (num === 0) return '-';

    const formatted = parseThousand(num, precision);
    // Only trim when there's a decimal point, so whole numbers keep their zeros.
    return trimTrailingZeros && formatted.includes('.')
      ? formatted.replace(/0+$/, '').replace(/\.$/, '')
      : formatted;
  };

  return (
    <div className="tw-flex tw-items-center tw-gap-0.5">
      {currency && currency.icon && (
        <img
          className={twMerge('tw-h-4 tw-w-4 tw-p-px', currencyClassName)}
          src={currency.icon}
          alt={currency.symbol}
        />
      )}
      <span aria-live={ariaLive ? 'polite' : 'off'} className={twMerge('tw-leading-4 tw-text-white', valueClassName)}>
        {renderValue(getValue(value ?? 0, false))}
      </span>
    </div>
  );
};

export default NftCardValue;
